import axios from '../axios';

class Reports{
    constructor() {
        this.activity = '/order/report/activity';
        this.incomplete = '/order/report/incomplete';
        this.food_sales = '/order/report/food_sales';
        this.beverage_sales = '/order/report/beverage_sales';
        this.alcohol_sales = '/order/report/alcohol_sales';
        this.food_and_beverage_sales = '/order/report/food_and_beverage_sales';
        this.game_sales = '/order/report/game_sales';
        this.total_sales = '/order/report/total_sales';
        this.all_transactions = '/order/report/allTransactions';
        this.all_items_per_completed_orders = '/order/report/allItemsPerCompletedOrders';
        this.all_item_choices_per_completed_orders = '/order/report/allItemChoicesPerCompletedOrders';
        this.send_email = '/printer/print';
        this.send_text = '/notification';
        this.complete_order = '/order/payment/cash/';
        this.get_menu_data = '/order/report/ordersByMenu';
        this.get_order_total_sales_by_day = '/order/report/orderTotalSalesByDay';
        this.get_summarized_menu_data = '/order/report/summerizedMenuData'
    }
    postCompleteOrder(params, order_id) {
        return axios(this.complete_order + order_id, { method: 'post', params });
    }
    postEmailReceipt(params) {
        return axios(this.send_email, { method: 'post', params });
    }
    postTextReceipt(params) {
        return axios(this.send_text, { method: 'post', params });
    }
    getActivity(params) {
        return axios(this.activity, { method: 'get', params });
    }
    getIncomplete(params) {
        return axios(this.incomplete, { method: 'get', params });
    }
    getFoodSales(params) {
        return axios(this.food_sales, { method: 'get', params });
    }
    getBeverageSales(params) {
        return axios(this.beverage_sales, { method: 'get', params });
    }
    getAlcoholSales(params) {
        return axios(this.alcohol_sales, { method: 'get', params });
    }
    getFoodAndBeverageSales(params) {
        return axios(this.food_and_beverage_sales, { method: 'get', params });
    }
    getGameSales(params) {
        return axios(this.game_sales, { method: 'get', params });
    }
    getRetailSales(params) {
        return axios(this.retail_sales, { method: 'get', params });
    }
    getMiscellaneousSales(params) {
        return axios(this.miscellaneous_sales, { method: 'get', params });
    }
    getTotalSales(params) {
        return axios(this.total_sales, { method: 'get', params });
    }
    getOrderTotalSalesByDay(params) {
        return axios(this.get_order_total_sales_by_day, {method: 'get', params});
    }
    getAllTransactions(params) {
        return axios(this.all_transactions, {method :'get', params});
    }
    getAllItemsPerCompletedOrders(params) {
        return axios(this.all_items_per_completed_orders, {method: 'get', params});
    }
    getAllItemChoicesPerCompletedOrders(params) {
        return axios(this.all_item_choices_per_completed_orders, {method: 'get', params});
    }
    getMenuReport(params) {
        return axios(this.get_menu_data, {method: 'get', params});
    }
    summarizedMenuData(params) {
        return axios(this.get_summarized_menu_data, {method: 'get', params});
    }
};
export default new Reports();



// WEBPACK FOOTER //
// ./src/api/modules/reports.js